document.querySelectorAll('.mfb-faq').forEach(root => {
  const search = root.querySelector('input[type="search"]');
  const buttons = [...root.querySelectorAll('[data-category]')];
  const groups = [...root.querySelectorAll('[data-group]')];
  const items = [...root.querySelectorAll('details')];
  const status = root.querySelector('[role="status"]');
  const empty = root.querySelector('.mfb-faq__empty');
  const openBeforeSearch = new Set();
  let selected = 'all';
  let searching = false;
  function update() {
    const term = search.value.trim().toLocaleLowerCase();
    if (term && !searching) items.filter(item => item.open).forEach(item => openBeforeSearch.add(item));
    if (!term && searching) {
      items.forEach(item => { item.open = openBeforeSearch.has(item); });
      openBeforeSearch.clear();
    }
    searching = Boolean(term);
    let total = 0;
    groups.forEach(group => {
      let count = 0;
      group.querySelectorAll('details').forEach(item => {
        const matches = (selected === 'all' || selected === group.dataset.group) && item.textContent.toLocaleLowerCase().includes(term);
        item.hidden = !matches;
        if (matches) { count++; if (term) item.open = true; }
      });
      group.hidden = count === 0;
      group.querySelector('[data-count]').textContent = `${count} ${count === 1 ? 'question' : 'questions'}`;
      total += count;
    });
    empty.hidden = total > 0;
    status.textContent = `${total} ${total === 1 ? 'question' : 'questions'}${term ? ' found' : ''}`;
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === selected)));
  }
  buttons.forEach(button => button.addEventListener('click', () => { selected = button.dataset.category; update(); }));
  search.addEventListener('input', update);
  root.querySelector('[data-clear]').addEventListener('click', () => { search.value = ''; selected = 'all'; update(); search.focus(); });
  update();
});
